import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  ADDRESS_COUNTRY,
  ADDRESS_STATE,
  CATEGORY,
  SOURCE,
  SPECIFIC_SENSITIVITY,
} from 'constants/formFields';
import { DEFAULT_OPTION } from 'constants/general';
import { geographicCreateSchema } from 'utils/validators';

import type { TGeographicCreateSchema } from 'utils/validators';
import type ICreateGeoForm from '../interfaces/ICreateGeoForm';

const useCreateGeoForm = ({ isPageLoading }: ICreateGeoForm) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty, isLoading },
    reset,
    setError,
    getValues,
    watch,
    setValue,
    resetField,
  } = useForm<TGeographicCreateSchema>({
    mode: 'onSubmit',
    resolver: yupResolver(geographicCreateSchema),
    defaultValues: {
      [ADDRESS_COUNTRY]: DEFAULT_OPTION,
      [CATEGORY]: DEFAULT_OPTION,
      [SOURCE]: [],
      [ADDRESS_STATE]: [],
      [SPECIFIC_SENSITIVITY]: DEFAULT_OPTION,
    },
  });

  useEffect(() => {
    if (!isPageLoading) {
      reset();
    }
  }, [reset, isPageLoading]);

  const fieldsName = Object.keys(getValues());

  return {
    control,
    handleSubmit,
    isDirty,
    reset,
    isLoading,
    setError,
    fieldsName,
    watch,
    setValue,
    resetField,
  };
};

export default useCreateGeoForm;
